<template>
  <div class="h-full w-full flex flex-col justify-between overflow-y-auto text-app-color">
    <div class="w-full max-w-300 mx-auto md:max-w-full md:pl-100 pt-35 md:pt-67 md:px-50 pb-50">
      <div class="flex items-center md:hidden" @click="back">
        <i class="text-12 mr-10 icon-keyboard-arrow-left opacity-50" />
        <p class="text-opacity-80">Back</p>
      </div>

      <h2 class="font-bold text-35 md:text-21">Trashed items</h2>
      <p class="text-15" :class="isDarkMode ? 'text-app-color' : 'text-dark-300'">All items will be permanently deleted after 20 days in trash</p>

      <!-- Mode -->
      <p class="font-bold mt-35">Spaces</p>
      <div v-if="trashedBooks.length">
        <TrashItem
          v-for="(book, index) in trashedBooks"
          :key="book.id"
          :has-size="false"
          :item="book"
          :class="{ 'border-b border-hover': index !== trashedProjects.length - 1}"
          @restore="restoreB(book.id)"
          @delete="deleteBook(book.id)"
        />
      </div>
      <div v-else class="text-14 text-grey-800">
        No spaces have been deleted yet
      </div>

      <p class="font-bold mt-35">Pages</p>
      <div v-if="trashedProjects.length">
        <TrashItem
          v-for="(project, index) in trashedProjects"
          :key="project.id"
          :item="project"
          :has-size="true"
          :size="sizes[project.id]"
          :icon="project.icon"
          :class="{ 'border-b border-hover': index !== trashedProjects.length - 1}"
          @restore="restoreP(project.id)"
          @delete="deleteProject(project.id)"
        />
      </div>
      <div v-else class="text-14 text-grey-800">
        No pages have been deleted yet
      </div>
    </div>
  </div>
</template>

<script>
import TrashItem from '@/components/settings/TrashItem'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { projectService, bookService } from '@/services'

export default {
  components: { TrashItem },

  emits: ['back'],

  computed: {
    ...mapState({
      trashedBooks: state => state.book.trash,
      trashedProjects: state => state.project.trash,
      sizes: state => state.project.sizes
    }),
    ...mapGetters(['isDarkMode'])
  },

  created () {
    this.getDeletedBooks()
    this.getDeletedProjects()
  },

  methods: {
    ...mapActions(['getDeletedBooks', 'getDeletedProjects', 'restoreBook', 'restoreProject']),
    ...mapMutations(['loading']),

    deleteBook (id) {
      bookService.permanentDelete(id).then(() => this.getDeletedBooks())
    },

    deleteProject (id) {
      projectService.permanentDelete(id).then(() => this.getDeletedProjects())
    },

    restoreB (id) {
      this.restoreBook(id).then(() => this.getDeletedBooks())
    },

    restoreP (id) {
      this.loading(true)
      this.restoreProject(id).then(() => this.getDeletedProjects())
    },

    back () {
      this.$emit('back')
    }
  }
}
</script>
